var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100px"}},[_c('v-chart',{ref:"graph",staticClass:"chart",attrs:{"option":_vm.opts,"id":"time-distribution-container","theme":_vm.theme}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }